type StarAnimation = {
  x?: gsap.TweenValue;
  y?: gsap.TweenValue;
  duration: number;
  yoyo?: boolean;
  repeat?: number;
  boxShadow?: string;
  scale?: number;
  alpha?: number;
  onComplete?: () => void;
};

type AnimateStarsArgs = {
  tl: GSAPTimeline;
  stars: React.RefObject<HTMLDivElement | null>[];
  animations: (StarAnimation | undefined)[];
  label: string | number;
  onEachStar?: (star: HTMLDivElement, index: number) => gsap.TweenVars;
};

export function animateStars({ tl, stars, animations, label, onEachStar }: AnimateStarsArgs) {
  animations.forEach((animation, index) => {
    const star = stars[index]?.current;

    if (!star || !animation) return;

    tl.to(
      star,
      {
        ...animation,
        ...(onEachStar ? onEachStar(star, index) : {}),
      },
      label
    );
  });
}
